import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  ForwardingIcon,

  Tracking,
  Workflow,
  Notifications,
  DocWorkflow,
  Generation,
  Transmission,
  Editor,
} from '../../assets';

const ForwardingPage = () => {
  const productData = {
    productName: 'Forwarding',
    tagline: 'End-to-End Forwarding Operations Made Simple',
    metaDescription: 'Manage air & ocean freight end-to-end: multimodal tracking, workflow milestones, HBL/MBL generation, and e-AWB transmission. Built for freight forwarders.',
    description: 'Optimize global trade with dedicated Air and Ocean modules. Real-time container tracking, unified documentation handling, and milestone management for freight forwarders.',
    icon: ForwardingIcon,
    features: [
      {
        title: 'Multimodal Tracking Automation',
        description: 'Track shipments across air, ocean, and land with automated milestone updates.',
        image: Tracking,
      },
      {
        title: 'Workflow & Milestone Management',
        description: 'Define custom workflows and track milestones for every shipment.',
        image: Workflow,
      },
      {
        title: 'Single-Click Multichannel Notifications',
        description: 'Keep customers informed with automated email, SMS, and WhatsApp updates.',
        image: Notifications,
      },
      {
        title: 'Document-Level Workflow for Forwarding & NVO',
        description: 'Manage complex documentation workflows for both forwarding and NVO operations.',
        image: DocWorkflow,
      },
      {
        title: 'Real-Time Document Editor',
        description: 'Edit documents in real-time with built-in compliance checks.',
        image: Editor,
      },
      {
        title: 'Single-Click Multimodal Document Generation',
        description: 'Generate HBL, MBL, AWB, and other documents with one click.',
        image: Generation,
      },
      {
        title: 'In-App E-AWB Transmission',
        description: 'Transmit electronic air waybills directly from the platform.',
        image: Transmission,
      },
    ],
    faqs: [
      {
        question: 'Does Shipmnts support both air and ocean freight forwarding?',
        answer: 'Yes. Shipmnts has dedicated modules for air freight (including e-AWB transmission) and ocean freight (FCL and LCL), with multimodal tracking, document generation, and milestone management for both.',
      },
      {
        question: 'Can I generate HBL, MBL, and AWB documents from Shipmnts?',
        answer: 'Yes. Shipmnts supports single-click generation of House Bills of Lading (HBL), Master Bills of Lading (MBL), Air Waybills (AWB), and other shipping documents with automated data population from shipment records.',
      },
      {
        question: 'Does Shipmnts support e-AWB transmission?',
        answer: 'Yes. Shipmnts enables in-app electronic Air Waybill (e-AWB) transmission directly to the airline, removing the need for paper AWBs and third-party transmission tools.',
      },
      {
        question: 'Can I track container and flight status in real time?',
        answer: 'Yes. Shipmnts provides automated multimodal tracking: ocean container movements via carrier APIs and air shipment milestones: with automated customer notifications via email, SMS, and WhatsApp.',
      },
      {
        question: 'Is Shipmnts suitable for NVOCCs?',
        answer: 'Yes. Shipmnts supports NVO (Non-Vessel Operating Common Carrier) operations with document-level workflows for both House and Master documentation, and separate handling for agent and shipper relationships.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default ForwardingPage;
